import styles from "./card-links.module.scss";
import { CardLinksStoryblok } from "@/types/component-types-sb";
import CardLink from "./CardLink";

interface Props {
  blok: CardLinksStoryblok;
}

const CardLinks = (props: Props) => {
  return (
    <div className={styles.wrapper}>
      {props.blok.items?.map((item) => (
        <CardLink key={item._uid} blok={item} />
      ))}
    </div>
  );
};

export default CardLinks;
